import { ModalContent } from "@kaltura/ds-react-components";
import styled from "@emotion/styled";

export const StyledModalContent = styled(ModalContent)(({ theme }) => ({
    overflow: "auto",
    flex: "1 1 auto",
}));

/**
 * actions inside the actions bar
 */
export const StyledActions = styled("div")<{
    hasBackButton?: boolean;
}>(({ theme, hasBackButton = false }) => ({
    display: "flex",
    justifyContent: hasBackButton ? "space-between" : "flex-end",
    width: "100%",
}));

/**
 * buttons inside the actions
 */
export const StyledActionButtons = styled("span")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
}));
